import { NgModule } from '@angular/core';
import { UsermanagementRoutingModule } from './usermanagement-routing.module';
import { UsersComponent } from './components/list/users.component';
import { UserAddEditComponent } from './components/manage/addedituser/addedituser.component';
import { UserprofileComponent } from './components/manage/userprofile/userprofile.component';
import { ChangePasswordComponent } from './components/manage/change-password/change-password.component';
import { ActionCellRendererComponent } from './components/list/action-cell-renderer.component';
import { StatusCellRendererComponent } from './components/list/status-cell-renderer.component';
import { SharedModule } from '../../shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

@NgModule({
  declarations: [
    UsersComponent,
    UserAddEditComponent,
    UserprofileComponent,
    ChangePasswordComponent,
    ActionCellRendererComponent,
    StatusCellRendererComponent
  ],
  imports: [
    SharedModule,
    UsermanagementRoutingModule,
    AgGridModule
  ],
  exports: [
    UserprofileComponent,
    ChangePasswordComponent
  ]
})
export class UsermanagementModule { }